<!--
 * @Author: your name
 * @Date: 2021-03-02 19:05:38
 * @LastEditTime: 2022-03-15 19:08:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\materialList.vue
-->
<template>
  <div class="attr-list">
    <div class="attr-title flex-c-c">
      <span style="font-size:18px;">{{$t('PE.properties')}}</span>
    </div>
    <div v-if="vdrList.length" class="attr-set">
      <div class="attr-rp">
        <regional-position :media="vdrList[vdrIndex]" />
      </div>
      <div class="attr-val">
        <component
          v-bind:is="currentComponent(getChildvdrIndex())"
          :media="vdrList[vdrIndex].wicket[vdrList[vdrIndex].activeIndex]"
        ></component>
      </div>
    </div>
    <div v-else class="flex-c-c">{{$t('PE.materialNull')}}</div>
    <div class="mask-layer" v-if="vdrInfor.type === 'look'"></div>
  </div>
</template>

<script>
import AttrWeather from './AttrList/AttrWeather'
import AttrCalendar from './AttrList/AttrCalendar'
import AttrCountdown from './AttrList/AttrCountdown'
import AttrIClock from './AttrList/AttrIClock'
import AttrImage from './AttrList/AttrImage'
import AttrMedia from './AttrList/AttrMedia'
import AttrNClock from './AttrList/AttrNClock'
import AttrRss from './AttrList/AttrRss'
import AttrText from './AttrList/AttrText'
import AttrTimewait from './AttrList/AttrTimewait'
import AttrVideo from './AttrList/AttrVideo'
import RegionalPosition from './AttrList/RegionalPosition'
import AttrWebpage from './AttrList/AttrWebpage'
import toolsList from '@/assets/scripts/toolsList.js';

export default {
  name: 'Attr',
  inject: {
    vdrInfor: {
      type: Object,
      default: () => { }
    }
  },
  components: {
    AttrWeather,
    AttrCalendar,
    AttrCountdown,
    AttrIClock,
    AttrImage,
    AttrMedia,
    AttrNClock,
    AttrRss,
    AttrText,
    AttrTimewait,
    AttrVideo,
    RegionalPosition,
    AttrWebpage
  },
  data() {
    return {
      toolsList: toolsList()
    }
  },
  methods: {
    currentComponent(type) {
      let tool = this.toolsList.find(tool => tool.type == type);
      if (tool) {
        return tool.attr;
      } else {
        return "";
      }
      // switch (type) {
      //   case "5": return "AttrWeather";
      //   // case "11": return "AttrCalendar";
      //   case "12": return "AttrCountdown";
      //   case "7": return "AttrIClock";
      //   case "2": return "AttrImage";
      //   case "14": return "AttrMedia";
      //   case "6": return "AttrNClock";
      //   case "17": return "AttrRss";
      //   case "4": return "AttrText";
      //   case "13": return "AttrTimewait";
      //   case "1": return "AttrVideo";
      //   default: return "";
      // }
    },
    getChildvdrIndex() {
      if (this.vdrList[this.vdrIndex].wicket.length > 0) {
        return this.vdrList[this.vdrIndex].wicket[this.vdrList[this.vdrIndex].activeIndex].type;
      } else {
        return "";
      }
    }
  },
  computed: {
    vdrList() {
      return this.$store.state.program.vdrList;
    },
    vdrIndex() {
      return this.$store.state.program.vdrIndex;
    },
    wicket() {
      return this.vdrList[this.vdrIndex];
    }
  },
  watch: {
    wicket: {
      handler() {
        this.vdrList.length > 0 && this.$store.commit("VDR_LIST_EDIT", this.vdrList[this.vdrIndex]);
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.attr-list {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  .attr-title {
    height: 40px;
    border-bottom: 1px solid #d7ecf3;
    font-family: 'Times New Roman';
    font-weight: normal;
    font-stretch: normal;
    line-height: 3px;
    letter-spacing: 3px;
    color: #617883;
  }
  .attr-set {
    height: calc(100% - 41px);
    .attr-rp {
      height: 100px;
    }
    .attr-val {
      height: calc(100% - 100px);
      overflow-y: auto;
      // margin: 0px 4px;
      margin-left: 4px;
    }
  }
  .mask-layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    cursor: not-allowed;
    // background: red;
  }
}
</style>